<template>
    <span>
      <b-card no-body>
        <b-card-header>
          <b-row>
            <b-col md="9">
              <h3 tabindex="0">Emitir Certificado</h3>
            </b-col>
          </b-row>
      </b-card-header>
        <b-row>
          <b-col sm="12">
            <b-container fluid>
              <span>
                <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7" class="table table-responsive-sm table-bordered table-striped table-sm">
                  <thead>
                    <tr>
                      <th tabindex="0" scope="col">Nome do Certificado</th>
                      <th tabindex="0" scope="col">Título do Certificado</th>
                      <th tabindex="0" scope="col">Certificado</th>
                      <th tabindex="0" scope="col">Status</th>
                      <th tabindex="0" scope="col">Ações</th>
                    </tr>
                  </thead>

                  <tbody v-if="certificados.data !== undefined">
                    <tr class="action" v-for="certificado in certificados.data" :key="certificado.id">
                      <td tabindex="0">{{certificado.nome}}</td>
                      <td tabindex="0">{{certificado.titulo}}</td>
                      <td tabindex="0">{{certificado.padrao == true ? 'Sim' : 'Não'}}</td>
                      <td>
                        <b-button size="sm" v-if="certificado.status === 'C'" pill variant="primary">Salvo</b-button>
                        <b-button size="sm" v-if="certificado.status === 'P'" pill variant="success">Publicado</b-button>
                        <b-button size="sm" v-if="certificado.status === 'R'" pill variant="danger">Rascunho</b-button>     
                      </td>
                      <td style="width: 23%">
                          <b-button class="btn btn-sm btn-secondary action" title="Gerar Certificado" @click="gerarCertificado(certificado.id)">
                            <i class="fa fa-file-pdf-o"></i>
                          </b-button>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr class="action">
                      <td tabindex="0" colspan="6">Nenhuma certificado encontrado</td>
                    </tr>
                  </tbody>
                </table>
                <pagination tabindex="0" v-show="certificados.data !== undefined" :totalPorPagina="totalPorPagina" :resource="resource" :filtros="filtros"></pagination>
              </span>
            </b-container>
          </b-col>
        </b-row>
      </b-card>
    </span>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import {eventType} from '@/components/shared/eventType'
import {DatePicker, setupCalendar} from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'
import SessionStorage from '@/services/session-storage'

setupCalendar({
  firstDayOfWeek: 2 // Monday
})

miniToastr.init()

export default {
  components: {
    Pagination,
    'v-date-picker': DatePicker,
    Multiselect
  },
  created () {   
    // if (!this.validaPerfil()) {
    //   this.$router.push('/')
    // }

  },
  data () {
    return {
      totalPorPagina: 10,
      resource: 'certificados',
      filtros: {
        filter: null,
        situacao: 'P',
        padrao: true
      },
      modalSituacao: false,
      novaSituacao: null,
      idCertificado: null,
      situacoes: [
        {'value': 'C', 'text': 'Salvo'},
        {'value': 'P', 'text': 'Publicado'},
        {'value': 'R', 'text': 'Rascunho'}
      ],
    }
  },
  computed: {
    certificados () {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    }
  },
  methods: {
    validaPerfil () {
      let perfil = this.$store.state.perfil.perfil     
      if (perfil.is_admin_conferencia) {
        return true
      }
      return false
    },
    setarFiltros (filtros) {
      eventType.$emit('app', filtros)
    },
    pesquisar () {
      this.$store.dispatch('getRegistrosSearch', {resource: 'certificados', limit: this.totalPorPagina, filtros: this.filtros})
      this.setarFiltros(this.filtros)
    },
    gerarCertificado(id) {
      let data = {
        id: null,
        user_id: SessionStorage.get('usuario')
      }

      Vue.http.post('api/certificado/emitirCertificado', data, {responseType: 'arraybuffer'}).then(response => {
          let blob = new Blob([response.data], { type: 'application/pdf' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'certificado participacao.pdf'
          link.click()

      }).catch(e => {
        console.log('Servidor está fora! ' + e)
      })
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
    .multiselect.invalid .multiselect__tags,
    .multiselect.invalid .multiselect__tags span,
    .multiselect.invalid .multiselect__tags input {
        background:red;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/certificados/CertificadoParticipante.vue